import React, { FC } from 'react';
import { Dialog, DialogTitle, DialogActions, Button, DialogProps } from '@material-ui/core';

interface ConfirmationDeleteCardDialogProps extends DialogProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmationDeleteCardDialog: FC<ConfirmationDeleteCardDialogProps> = ({
  onCancel,
  onConfirm,
  open,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Wil je deze kaart verwijderen?'}</DialogTitle>
      <DialogActions>
        <Button onClick={onCancel}>Annuleren</Button>
        <Button
          style={{ height: '36px' }}
          size="small"
          disabled={false}
          color="primary"
          variant="contained"
          onClick={onConfirm}
          disableElevation={true}
        >
          {'Verwijderen'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
